import HeroSection from '../components/home/HeroSection'

function Home() {
  return (
    <div className="min-h-screen bg-gray-950">
      <HeroSection />
    </div>
  )
}

export default Home
